import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "create-update-estimatif-line" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Désignation de l'ouvrage")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Titre")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Principal", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Secondaire", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Non Chiffrable")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Non Chiffrable", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Gras (Word)", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Souligné (Word)", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Unité")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "TVA")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Prix Unitaire")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_number_format = _resolveComponent("number-format")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.internalEstimatifLine)
      ? (_openBlock(), _createBlock(_component_a_form, {
          key: 0,
          model: _ctx.internalEstimatifLine,
          "validate-messages": _ctx.validateMessages,
          autocomplete: "off",
          onFinish: _ctx.submitCreateOrUpdateEstimatifLineHandler
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              name: ['designation'],
              rules: [{ required: true }],
              "has-feedback": "",
              "label-Col": {span: 6}
            }, {
              label: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.internalEstimatifLine.designation,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalEstimatifLine.designation) = $event)),
                  placeholder: "Désignation de l'ouvrage",
                  "auto-size": ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { "label-Col": {span: 6} }, {
              label: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createVNode(_component_a_switch, {
                      checked: _ctx.internalEstimatifLine.isPrincipalTitle,
                      "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internalEstimatifLine.isPrincipalTitle) = $event))
                    }, null, 8, ["checked"]),
                    _hoisted_5,
                    _createVNode(_component_a_switch, {
                      checked: _ctx.internalEstimatifLine.isSecondaryTitle,
                      "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.internalEstimatifLine.isSecondaryTitle) = $event))
                    }, null, 8, ["checked"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!_ctx.isTitleSelected)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  "label-Col": {span: 6}
                }, {
                  label: _withCtx(() => [
                    _hoisted_6
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createVNode(_component_a_switch, {
                          checked: _ctx.internalEstimatifLine.isNonChiffrable,
                          "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.internalEstimatifLine.isNonChiffrable) = $event))
                        }, null, 8, ["checked"]),
                        (_ctx.internalEstimatifLine.isNonChiffrable)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_8,
                              _createVNode(_component_a_switch, {
                                checked: _ctx.internalEstimatifLine.isNonChiffrableBold,
                                "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.internalEstimatifLine.isNonChiffrableBold) = $event))
                              }, null, 8, ["checked"]),
                              _hoisted_9,
                              _createVNode(_component_a_switch, {
                                checked: _ctx.internalEstimatifLine.isNonChiffrableUnderline,
                                "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.internalEstimatifLine.isNonChiffrableUnderline) = $event))
                              }, null, 8, ["checked"])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isNonChiffrableSelected)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_a_form_item, { "label-Col": {span: 6} }, {
                    label: _withCtx(() => [
                      _hoisted_10
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.internalEstimatifLine.uniteId,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.internalEstimatifLine.uniteId) = $event)),
                        placeholder: "Unité",
                        style: {"width":"170px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unites, (unite) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: unite.uniteId,
                              value: unite.uniteId
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(unite.libelle) + " (" + _toDisplayString(unite.code) + ") ", 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { "label-Col": {span: 6} }, {
                    label: _withCtx(() => [
                      _hoisted_11
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.internalEstimatifLine.tvaId,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.internalEstimatifLine.tvaId) = $event)),
                        placeholder: "TVA",
                        style: {"width":"110px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tvas, (tva) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: tva.tvaId,
                              value: tva.tvaId
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_number_format, {
                                  value: tva.taux,
                                  options: _ctx.percentageValueOptions
                                }, null, 8, ["value", "options"])
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { "label-Col": {span: 6} }, {
                    label: _withCtx(() => [
                      _hoisted_12
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_number, {
                        value: _ctx.internalEstimatifLine.prixUnitaire,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.internalEstimatifLine.prixUnitaire) = $event)),
                        "addon-after": "€",
                        controls: false,
                        decimalSeparator: ",",
                        placeholder: "Prix Unitaire",
                        style: {"width":"130px"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  type: "flex",
                  class: "actions"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      flex: "auto",
                      align: "left"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          class: "btn-warning",
                          onClick: _ctx.close
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Annuler ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          "html-type": "submit"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.internalEstimatifLine.estimatifId > 0 ? "Mettre à jour" : "Créer"), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "validate-messages", "onFinish"]))
      : _createCommentVNode("", true)
  ]))
}